import React, { useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useRouter } from 'next/router';
import { getProfileWithSlug } from 'app/dispatcher/profileDispatcher';
import {
  getProfileForConfigurePageHead,
  getProfileLatestCredentials,
} from 'app/reducer/profileRedux';
import { configureProfilePageHead } from 'app/utils/configurePageHead';

import PageHead from 'app/components/misc/PageHead';
import Page from 'app/components/misc/BasePage';
import ProfileContent from 'app/pageContents/ProfileContent';

const Profile = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const profilePageHead = useSelector(getProfileForConfigurePageHead);

  const { slug } = router.query;

  const latestCredential = useSelector(
    getProfileLatestCredentials,
    shallowEqual,
  );

  useEffect(() => {
    dispatch(getProfileWithSlug({ slug }));
  }, [dispatch, slug]);

  return (
    <Page>
      <PageHead
        {...configureProfilePageHead(profilePageHead, latestCredential)}
      />
      <ProfileContent />
    </Page>
  );
};

export default Profile;
